// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__XmEMy","active":"Navigation_active__TI38Z"};